import React, { Component } from "react";
import { Link } from "react-router";
import NavBar from "../components/layout/NavBar";
import LandingFooter from "../components/layout/LandingFooter";
import AuthService from "../services/AuthService";
import StravaAccountCard from "../components/strava/StravaAccountCard";
import {
  Button,
  Modal,
  Input,
  PasswordInput,
  Toast,
  Spinner,
} from "../components/ui";
import {
  ArrowLeft,
  Shield,
  User,
  Key,
  LogOut,
  UserCheck,
  CreditCard,
  Phone,
  Mail,
  Lock,
  Trophy,
  Search,
  LayoutDashboard,
  Check,
  Edit2,
  ArrowRight,
} from "lucide-react";

function formatCPF(cpf) {
  if (!cpf) return "-";
  const cleaned = ("" + cpf).replace(/\D/g, "");
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  return cpf;
}

function formatPhone(phone) {
  if (!phone) return "-";
  const cleaned = ("" + phone).replace(/\D/g, "");
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return phone;
}

function maskCPF(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 9) {
    return v.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2})/, "$1.$2.$3-$4");
  } else if (v.length > 6) {
    return v.replace(/^(\d{3})(\d{3})(\d{1,3})/, "$1.$2.$3");
  } else if (v.length > 3) {
    return v.replace(/^(\d{3})(\d{1,3})/, "$1.$2");
  }
  return v;
}

function maskPhone(value) {
  if (!value) return "";
  let v = value.replace(/\D/g, "");
  if (v.length > 11) v = v.substring(0, 11);
  if (v.length > 10) {
    return v.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (v.length > 6) {
    return v.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
  } else if (v.length > 2) {
    return v.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
  }
  return v;
}

function validateCPF(cpfStr) {
  let strCPF = (cpfStr || "").replace(/[^\d]+/g, "");
  if (strCPF === "" || strCPF.length !== 11 || /^(\d)\1{10}$/.test(strCPF))
    return false;
  let soma = 0;
  for (let i = 1; i <= 9; i++)
    soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

function getInitials(firstName, lastName, fallback = "U") {
  const f = (firstName || "").trim().charAt(0);
  const l = (lastName || "").trim().charAt(0);
  const initials = `${f}${l}`.toUpperCase();
  return initials || (fallback ? fallback.charAt(0).toUpperCase() : "U");
}

class PerfilUsuario extends Component {
  constructor() {
    super();
    this.state = {
      usuarios: {},
      loadingUser: true,
      visible: false,
      new_psw: "",
      confirm_psw: "",
      loadingSenha: false,
      visibleEditProfile: false,
      editFirstName: "",
      editLastName: "",
      editEmail: "",
      editCpf: "",
      editTelefone: "",
      loadingEditProfile: false,
    };
    this.toast = React.createRef();
    this.authservice = new AuthService();
  }

  componentDidMount() {
    const userId = sessionStorage.getItem("brv-user-id");
    if (userId) {
      this.authservice
        .getUserData(userId)
        .then((res) => {
          if (!res.ok) throw new Error("Erro ao buscar dados");
          return res.json();
        })
        .then((data) =>
          this.setState({ usuarios: data, loadingUser: false })
        )
        .catch((err) => {
          console.error(err);
          this.setState({ loadingUser: false });
          this.showToast(
            "error",
            "Erro",
            "Não foi possível carregar os dados do perfil."
          );
        });
    } else {
      this.setState({ loadingUser: false });
    }
  }

  showToast = (severity, summary, detail) => {
    if (this.toast.current) {
      this.toast.current.show({ severity, summary, detail, life: 4000 });
    }
  };

  handleLogout = () => {
    sessionStorage.removeItem("brv-user-token");
    sessionStorage.removeItem("brv-user");
    sessionStorage.removeItem("brv-user-id");
    sessionStorage.removeItem("brv-tipo-user");
    sessionStorage.removeItem("brv-id-inscricao");

    window.location.replace("/");
  };

  handleUpdateSenha = async (e) => {
    if (e) e.preventDefault();
    const { new_psw, confirm_psw } = this.state;

    if (!new_psw) {
      this.showToast("warn", "Atenção", "Informe a nova senha.");
      return;
    }

    if (new_psw.length < 6) {
      this.showToast(
        "warn",
        "Atenção",
        "A senha deve ter pelo menos 6 caracteres."
      );
      return;
    }

    if (new_psw !== confirm_psw) {
      this.showToast("error", "Erro", "As senhas digitadas não coincidem.");
      return;
    }

    this.setState({ loadingSenha: true });

    const data = {
      nova_senha: new_psw,
      confirma_nova_senha: confirm_psw,
    };

    try {
      const response = await this.authservice.setMudaSenha(
        JSON.stringify(data)
      );
      if (response.status === 200 || response.ok) {
        this.showToast(
          "success",
          "Sucesso!",
          "Senha alterada com sucesso! Redirecionando..."
        );
        this.setState({ visible: false, new_psw: "", confirm_psw: "" });
        setTimeout(() => {
          this.handleLogout();
        }, 2000);
      } else {
        const resData = await response.json().catch(() => ({}));
        const errorMsg =
          resData?.detail ||
          resData?.erro ||
          resData?.nova_senha?.[0] ||
          "Erro ao alterar a senha. Tente novamente.";
        this.showToast("error", "Erro!", errorMsg);
      }
    } catch (err) {
      console.error(err);
      this.showToast("error", "Erro!", "Falha de comunicação com o servidor.");
    } finally {
      this.setState({ loadingSenha: false });
    }
  };

  handleOpenEditProfile = () => {
    const { usuarios } = this.state;
    this.setState({
      visibleEditProfile: true,
      editFirstName: usuarios.first_name || "",
      editLastName: usuarios.last_name || "",
      editEmail: usuarios.email || "",
      editCpf: maskCPF(usuarios.cpf || ""),
      editTelefone: maskPhone(usuarios.telefone1 || usuarios.telefone || ""),
    });
  };

  handleCloseEditProfile = () => {
    if (!this.state.loadingEditProfile) {
      this.setState({ visibleEditProfile: false });
    }
  };

  handleUpdateProfile = async (e) => {
    if (e) e.preventDefault();
    const {
      editFirstName,
      editLastName,
      editEmail,
      editCpf,
      editTelefone,
      usuarios,
    } = this.state;

    if (!editFirstName || !editFirstName.trim()) {
      this.showToast("warn", "Atenção", "Informe seu nome.");
      return;
    }

    if (!editLastName || !editLastName.trim()) {
      this.showToast("warn", "Atenção", "Informe seu sobrenome.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!editEmail || !emailRegex.test(editEmail.trim())) {
      this.showToast("warn", "Atenção", "Informe um e-mail válido.");
      return;
    }

    const cleanCpf = editCpf.replace(/\D/g, "");
    if (!cleanCpf || !validateCPF(cleanCpf)) {
      this.showToast("warn", "Atenção", "Informe um CPF válido.");
      return;
    }

    const cleanPhone = editTelefone.replace(/\D/g, "");
    if (!cleanPhone || cleanPhone.length < 10) {
      this.showToast(
        "warn",
        "Atenção",
        "Informe um telefone válido com DDD (mínimo 10 dígitos)."
      );
      return;
    }

    this.setState({ loadingEditProfile: true });

    const userId = sessionStorage.getItem("brv-user-id");
    const originalCpf = (usuarios.cpf || "").replace(/\D/g, "");
    
    const payload = {
      first_name: editFirstName.trim(),
      last_name: editLastName.trim(),
      nome: editFirstName.trim(),
      sobrenome: editLastName.trim(),
      email: editEmail.trim(),
      telefone1: cleanPhone,
      telefone: cleanPhone,
      id_usuario: userId ? parseInt(userId) : undefined,
    };

    if (cleanCpf !== originalCpf) {
      payload.cpf = cleanCpf;
    }

    try {
      const response = await this.authservice.updatePerfil(payload);
      
      // Atualizar também informações adicionais (CPF/Telefone) via endpoint exclusivo /core/user/update/<int:pk>/
      if (userId) {
        try {
          const infoPayload = {
            telefone: cleanPhone,
            telefone1: cleanPhone
          };
          if (cleanCpf !== originalCpf) {
            infoPayload.cpf = cleanCpf;
          }
          await this.authservice.updateInfoAdicional(userId, infoPayload);
        } catch (errInfo) {
          console.error("Erro ao atualizar info adicional", errInfo);
        }
      }

      if (
        response.ok ||
        response.status === 200 ||
        response.status === 204
      ) {
        let updatedData = {};
        try {
          updatedData = await response.json();
        } catch (err) {}

        const updatedUser = {
          ...usuarios,
          ...updatedData,
          first_name: editFirstName.trim(),
          last_name: editLastName.trim(),
          email: editEmail.trim(),
          cpf: cleanCpf,
          telefone1: cleanPhone,
          telefone: cleanPhone,
        };

        sessionStorage.setItem("brv-user", editFirstName.trim());

        this.setState({
          usuarios: updatedUser,
          visibleEditProfile: false,
          loadingEditProfile: false,
        });

        this.showToast(
          "success",
          "Sucesso!",
          "Informações do perfil atualizadas com sucesso!"
        );
      } else {
        let errorMsg = "Erro ao atualizar dados do perfil. Tente novamente.";
        try {
          const resData = await response.json();
          if (typeof resData === "object" && resData !== null) {
            if (resData.detail) {
              errorMsg = resData.detail;
            } else if (resData.erro || resData.error || resData.mensagem) {
              errorMsg = resData.erro || resData.error || resData.mensagem;
            } else {
              const parts = [];
              for (const [key, val] of Object.entries(resData)) {
                const valStr = Array.isArray(val) ? val.join(", ") : String(val);
                parts.push(`${key}: ${valStr}`);
              }
              if (parts.length > 0) errorMsg = parts.join(" | ");
            }
          }
        } catch (e) {}
        this.showToast("error", "Erro!", errorMsg);
        this.setState({ loadingEditProfile: false });
      }
    } catch (err) {
      console.error(err);
      this.showToast(
        "error",
        "Erro!",
        "Falha de comunicação com o servidor ao atualizar perfil."
      );
      this.setState({ loadingEditProfile: false });
    }
  };

  render() {
    const {
      usuarios,
      loadingUser,
      visible,
      new_psw,
      confirm_psw,
      loadingSenha,
      visibleEditProfile,
      editFirstName,
      editLastName,
      editEmail,
      editCpf,
      editTelefone,
      loadingEditProfile,
    } = this.state;
    const tipoUsuario = sessionStorage.getItem("brv-tipo-user") || "Corredor";
    const sessionUser = sessionStorage.getItem("brv-user") || "";
    const nomeExibicao = usuarios.first_name
      ? `${usuarios.first_name} ${usuarios.last_name || ""}`.trim()
      : sessionUser || "Usuário";
    const userInitials = getInitials(
      usuarios.first_name,
      usuarios.last_name,
      sessionUser || "U"
    );
    const backUrl =
      tipoUsuario === "Organizador" ? "/dashboard" : "/minhas-corridas";
    const isOrganizador = tipoUsuario === "Organizador";

    return (
      <div className="min-h-screen flex flex-col justify-between bg-urb-dark text-slate-100 selection:bg-urb-primary selection:text-black">
        <Toast ref={this.toast} />

        {/* Header Navigation */}
        <header>
          <NavBar />
        </header>

        {/* Main Content Area */}
        <main className="flex-1 py-8 px-4 md:px-8 max-w-7xl mx-auto w-full box-border">
          {/* Top Breadcrumb / Return Link */}
          <div className="mb-6 flex items-center justify-between">
            <Link
              to={backUrl}
              className="inline-flex items-center gap-2 text-xs md:text-sm font-medium no-underline transition-colors text-slate-400 hover:text-white"
            >
              <ArrowLeft className="w-4 h-4 text-urb-primary" />
              <span>
                Voltar para{" "}
                {isOrganizador ? "Painel do Organizador" : "Minhas Corridas"}
              </span>
            </Link>
          </div>

          {loadingUser ? (
            <div className="flex flex-col items-center justify-center py-20 gap-4">
              <Spinner size="lg" />
              <span className="text-sm text-slate-400">
                Carregando dados do perfil...
              </span>
            </div>
          ) : (
            <div className="flex flex-col gap-6">
              {/* Profile Header Hero Card */}
              <div className="w-full rounded-3xl border border-urb-border p-6 md:p-8 bg-urb-card/90 shadow-2xl relative overflow-hidden flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
                {/* User Info & Avatar */}
                <div className="flex items-center gap-4 sm:gap-6 w-full lg:w-auto min-w-0">
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl flex items-center justify-center shrink-0 font-black text-xl sm:text-2xl bg-urb-primary/10 text-urb-primary border-2 border-urb-primary/30 shadow-xl">
                    {userInitials}
                  </div>

                  <div className="flex flex-col text-left gap-1 min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-3">
                      <h1 className="text-xl sm:text-2xl md:text-3xl font-black text-white m-0 tracking-tight break-words">
                        {nomeExibicao}
                      </h1>
                      {/* Role Badge */}
                      <span
                        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold shrink-0 ${
                          isOrganizador
                            ? "bg-amber-500/10 text-amber-400 border border-amber-500/30"
                            : "bg-urb-primary/10 text-urb-primary border border-urb-primary/30"
                        }`}
                      >
                        {isOrganizador ? (
                          <Shield className="w-3.5 h-3.5" />
                        ) : (
                          <User className="w-3.5 h-3.5" />
                        )}
                        {tipoUsuario}
                      </span>
                    </div>
                    <span className="text-xs sm:text-sm text-slate-400 break-all">
                      {usuarios.email || "E-mail não informado"}
                    </span>
                  </div>
                </div>

                {/* Header Action Buttons */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
                  <Button
                    variant="primary"
                    size="md"
                    type="button"
                    onClick={this.handleOpenEditProfile}
                    className="font-bold text-xs uppercase flex items-center justify-center gap-2"
                  >
                    <Edit2 className="w-3.5 h-3.5" />
                    Editar Perfil
                  </Button>
                  <Button
                    variant="secondary"
                    size="md"
                    type="button"
                    onClick={() =>
                      this.setState({
                        visible: true,
                        new_psw: "",
                        confirm_psw: "",
                      })
                    }
                    className="font-semibold text-xs flex items-center justify-center gap-2"
                  >
                    <Key className="w-3.5 h-3.5" />
                    Trocar Senha
                  </Button>
                  <button
                    type="button"
                    onClick={this.handleLogout}
                    className="px-4 py-2.5 rounded-xl font-semibold text-xs border border-red-500/30 bg-red-500/10 text-red-400 hover:bg-red-500/20 transition-all flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <LogOut className="w-3.5 h-3.5" />
                    Sair
                  </button>
                </div>
              </div>

              {/* Detailed Information Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Card 1: Dados Pessoais */}
                <div className="rounded-2xl border border-urb-border p-6 bg-urb-card/70 flex flex-col justify-between shadow-xl">
                  <div>
                    <div className="flex items-center justify-between pb-3 mb-4 border-b border-urb-border">
                      <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-lg bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center shrink-0">
                          <User className="w-4 h-4 text-urb-primary" />
                        </div>
                        <h2 className="text-base font-bold text-white m-0">
                          Dados Pessoais
                        </h2>
                      </div>
                      <button
                        type="button"
                        onClick={this.handleOpenEditProfile}
                        className="text-xs text-urb-primary font-bold hover:underline flex items-center gap-1 bg-transparent border-none cursor-pointer"
                      >
                        <Edit2 className="w-3 h-3" /> Editar
                      </button>
                    </div>

                    <div className="flex flex-col gap-3">
                      {/* Nome Completo */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
                        <UserCheck className="w-5 h-5 text-slate-400 shrink-0" />
                        <div className="flex flex-col min-w-0">
                          <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                            Nome Completo
                          </span>
                          <span className="text-xs sm:text-sm font-semibold text-white break-words">
                            {usuarios.first_name
                              ? `${usuarios.first_name} ${
                                  usuarios.last_name || ""
                                }`.trim()
                              : "-"}
                          </span>
                        </div>
                      </div>

                      {/* CPF */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
                        <CreditCard className="w-5 h-5 text-slate-400 shrink-0" />
                        <div className="flex flex-col min-w-0">
                          <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                            CPF
                          </span>
                          <span className="text-xs sm:text-sm font-semibold text-white">
                            {formatCPF(usuarios.cpf)}
                          </span>
                        </div>
                      </div>

                      {/* Telefone / WhatsApp */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center gap-3">
                        <Phone className="w-5 h-5 text-slate-400 shrink-0" />
                        <div className="flex flex-col min-w-0">
                          <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                            Telefone / WhatsApp
                          </span>
                          <span className="text-xs sm:text-sm font-semibold text-white">
                            {formatPhone(
                              usuarios.telefone1 || usuarios.telefone
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Card 2: Informações da Conta & Segurança */}
                <div className="rounded-2xl border border-urb-border p-6 bg-urb-card/70 flex flex-col justify-between shadow-xl">
                  <div>
                    <div className="flex items-center gap-2.5 pb-3 mb-4 border-b border-urb-border">
                      <div className="w-8 h-8 rounded-lg bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center shrink-0">
                        <Shield className="w-4 h-4 text-urb-primary" />
                      </div>
                      <h2 className="text-base font-bold text-white m-0">
                        Conta & Segurança
                      </h2>
                    </div>

                    <div className="flex flex-col gap-3">
                      {/* E-mail */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3 min-w-0">
                          <Mail className="w-5 h-5 text-slate-400 shrink-0" />
                          <div className="flex flex-col min-w-0">
                            <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                              E-mail de Acesso
                            </span>
                            <span className="text-xs sm:text-sm font-semibold text-white break-all">
                              {usuarios.email || "-"}
                            </span>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={this.handleOpenEditProfile}
                          className="text-xs text-urb-primary font-bold hover:underline bg-transparent border-none cursor-pointer shrink-0"
                        >
                          Editar
                        </button>
                      </div>

                      {/* Tipo de Perfil */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3 min-w-0">
                          <User className="w-5 h-5 text-slate-400 shrink-0" />
                          <div className="flex flex-col min-w-0">
                            <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                              Tipo de Usuário
                            </span>
                            <span className="text-xs sm:text-sm font-semibold text-white">
                              {tipoUsuario}
                            </span>
                          </div>
                        </div>
                        <span className="px-2.5 py-0.5 rounded-full text-xs font-bold bg-urb-primary/10 text-urb-primary border border-urb-primary/30">
                          Ativo
                        </span>
                      </div>

                      {/* Senha */}
                      <div className="p-3.5 rounded-xl border border-slate-800 bg-slate-950/70 flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3 min-w-0">
                          <Lock className="w-5 h-5 text-slate-400 shrink-0" />
                          <div className="flex flex-col min-w-0">
                            <span className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold">
                              Senha
                            </span>
                            <span className="text-xs sm:text-sm font-semibold text-white">
                              ••••••••••••
                            </span>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() =>
                            this.setState({
                              visible: true,
                              new_psw: "",
                              confirm_psw: "",
                            })
                          }
                          className="text-xs text-urb-primary font-bold hover:underline bg-transparent border-none cursor-pointer shrink-0"
                        >
                          Alterar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Seção de Integrações */}
              <div className="w-full">
                <StravaAccountCard />
              </div>

              {/* Quick Action Cards / Atalhos */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {isOrganizador ? (
                  <>
                    <Link to="/dashboard" className="no-underline block">
                      <div className="rounded-2xl border border-urb-border p-5 flex items-center justify-between bg-urb-card/70 hover:border-urb-primary/50 transition-all cursor-pointer shadow-lg group">
                        <div className="flex items-center gap-4 min-w-0">
                          <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-urb-primary/10 border border-urb-primary/30 text-urb-primary shrink-0">
                            <LayoutDashboard className="w-6 h-6" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-sm sm:text-base font-bold text-white group-hover:text-urb-primary transition-colors">
                              Painel do Organizador
                            </span>
                            <span className="text-xs text-slate-400 truncate">
                              Acesse métricas, inscrições e relatórios
                            </span>
                          </div>
                        </div>
                        <ArrowRight className="w-5 h-5 text-urb-primary shrink-0 ml-2" />
                      </div>
                    </Link>
                    <Link to="/eventos" className="no-underline block">
                      <div className="rounded-2xl border border-urb-border p-5 flex items-center justify-between bg-urb-card/70 hover:border-urb-primary/50 transition-all cursor-pointer shadow-lg group">
                        <div className="flex items-center gap-4 min-w-0">
                          <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-urb-primary/10 border border-urb-primary/30 text-urb-primary shrink-0">
                            <Trophy className="w-6 h-6" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-sm sm:text-base font-bold text-white group-hover:text-urb-primary transition-colors">
                              Gerenciar Eventos
                            </span>
                            <span className="text-xs text-slate-400 truncate">
                              Crie novos eventos ou edite existentes
                            </span>
                          </div>
                        </div>
                        <ArrowRight className="w-5 h-5 text-urb-primary shrink-0 ml-2" />
                      </div>
                    </Link>
                  </>
                ) : (
                  <>
                    <Link to="/minhas-corridas" className="no-underline block">
                      <div className="rounded-2xl border border-urb-border p-5 flex items-center justify-between bg-urb-card/70 hover:border-urb-primary/50 transition-all cursor-pointer shadow-lg group">
                        <div className="flex items-center gap-4 min-w-0">
                          <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-urb-primary/10 border border-urb-primary/30 text-urb-primary shrink-0">
                            <Trophy className="w-6 h-6" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-sm sm:text-base font-bold text-white group-hover:text-urb-primary transition-colors">
                              Minhas Corridas
                            </span>
                            <span className="text-xs text-slate-400 truncate">
                              Veja suas provas inscritas e resultados
                            </span>
                          </div>
                        </div>
                        <ArrowRight className="w-5 h-5 text-urb-primary shrink-0 ml-2" />
                      </div>
                    </Link>
                    <Link to="/novas-corridas" className="no-underline block">
                      <div className="rounded-2xl border border-urb-border p-5 flex items-center justify-between bg-urb-card/70 hover:border-urb-primary/50 transition-all cursor-pointer shadow-lg group">
                        <div className="flex items-center gap-4 min-w-0">
                          <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-urb-primary/10 border border-urb-primary/30 text-urb-primary shrink-0">
                            <Search className="w-6 h-6" />
                          </div>
                          <div className="flex flex-col min-w-0">
                            <span className="text-sm sm:text-base font-bold text-white group-hover:text-urb-primary transition-colors">
                              Explorar Novas Corridas
                            </span>
                            <span className="text-xs text-slate-400 truncate">
                              Descubra provas disponíveis para inscrição
                            </span>
                          </div>
                        </div>
                        <ArrowRight className="w-5 h-5 text-urb-primary shrink-0 ml-2" />
                      </div>
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}

          {/* Dialog: Editar Perfil */}
          <Modal
            isOpen={visibleEditProfile}
            onClose={this.handleCloseEditProfile}
            title={
              <div className="flex items-center gap-2 text-white">
                <Edit2 className="w-5 h-5 text-urb-primary" />
                <span className="font-bold text-base">Editar Perfil</span>
              </div>
            }
            maxWidth="max-w-lg"
          >
            <form onSubmit={this.handleUpdateProfile} className="flex flex-col gap-4">
              <p className="text-xs m-0 text-slate-400">
                Atualize suas informações pessoais. Todos os dados são salvos
                com segurança.
              </p>

              {/* Nome e Sobrenome */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-semibold text-slate-300">
                    Nome *
                  </label>
                  <Input
                    value={editFirstName}
                    onChange={(e) =>
                      this.setState({ editFirstName: e.target.value })
                    }
                    placeholder="Seu nome"
                    required
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-semibold text-slate-300">
                    Sobrenome *
                  </label>
                  <Input
                    value={editLastName}
                    onChange={(e) =>
                      this.setState({ editLastName: e.target.value })
                    }
                    placeholder="Seu sobrenome"
                    required
                  />
                </div>
              </div>

              {/* E-mail */}
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-slate-300">
                  E-mail *
                </label>
                <Input
                  type="email"
                  value={editEmail}
                  onChange={(e) =>
                    this.setState({ editEmail: e.target.value })
                  }
                  placeholder="seuemail@exemplo.com"
                  required
                />
              </div>

              {/* CPF */}
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-slate-300">
                  CPF *
                </label>
                <Input
                  value={editCpf}
                  onChange={(e) =>
                    this.setState({ editCpf: maskCPF(e.target.value) })
                  }
                  placeholder="000.000.000-00"
                  maxLength={14}
                  required
                />
              </div>

              {/* Telefone / WhatsApp */}
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-slate-300">
                  Telefone / WhatsApp *
                </label>
                <Input
                  value={editTelefone}
                  onChange={(e) =>
                    this.setState({ editTelefone: maskPhone(e.target.value) })
                  }
                  placeholder="(00) 00000-0000"
                  maxLength={15}
                  required
                />
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3 pt-3 border-t border-urb-border">
                <Button
                  variant="secondary"
                  size="md"
                  type="button"
                  disabled={loadingEditProfile}
                  onClick={this.handleCloseEditProfile}
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  size="md"
                  type="submit"
                  disabled={loadingEditProfile}
                  loading={loadingEditProfile}
                  className="font-bold flex items-center gap-1.5"
                >
                  <Check className="w-4 h-4" />
                  Salvar Alterações
                </Button>
              </div>
            </form>
          </Modal>

          {/* Dialog: Alterar Senha */}
          <Modal
            isOpen={visible}
            onClose={() => {
              if (!loadingSenha) {
                this.setState({ visible: false, new_psw: "", confirm_psw: "" });
              }
            }}
            title={
              <div className="flex items-center gap-2 text-white">
                <Key className="w-5 h-5 text-urb-primary" />
                <span className="font-bold text-base">Alterar Senha</span>
              </div>
            }
            maxWidth="max-w-md"
          >
            <form onSubmit={this.handleUpdateSenha} className="flex flex-col gap-4">
              <p className="text-xs m-0 text-slate-400">
                Digite a sua nova senha. Após a alteração, sua sessão será
                encerrada para que você faça login novamente.
              </p>

              {/* Nova Senha */}
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-slate-300">
                  Nova Senha
                </label>
                <PasswordInput
                  value={new_psw}
                  onChange={(e) => this.setState({ new_psw: e.target.value })}
                  placeholder="Mínimo de 6 caracteres"
                  required
                />
              </div>

              {/* Confirmar Nova Senha */}
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-slate-300">
                  Confirmar Nova Senha
                </label>
                <PasswordInput
                  value={confirm_psw}
                  onChange={(e) =>
                    this.setState({ confirm_psw: e.target.value })
                  }
                  placeholder="Repita a nova senha"
                  required
                />
              </div>

              {/* Actions */}
              <div className="flex items-center justify-end gap-3 pt-3 border-t border-urb-border">
                <Button
                  variant="secondary"
                  size="md"
                  type="button"
                  disabled={loadingSenha}
                  onClick={() =>
                    this.setState({ visible: false, new_psw: "", confirm_psw: "" })
                  }
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  size="md"
                  type="submit"
                  disabled={loadingSenha}
                  loading={loadingSenha}
                  className="font-bold flex items-center gap-1.5"
                >
                  <Check className="w-4 h-4" />
                  Atualizar Senha
                </Button>
              </div>
            </form>
          </Modal>
        </main>

        {/* Footer */}
        <LandingFooter />
      </div>
    );
  }
}

export default PerfilUsuario;